import React from "react";
import PropTypes from "prop-types";
import "./index.css";

const CustomErrorComponent = ({ error }) => {
  if (!error) {
    return null;
  }

  return (
    <div className="custom-error-container">
      <h1 className="custom-error-title">¡Ups! Algo salió mal</h1>
      <p className="custom-error-message">
        No pudimos completar el proceso de autenticación. Por favor, intente nuevamente.
      </p>

      {error && (
        <details className="custom-error-details">
          <summary>Detalles del Error</summary>
          <pre>{JSON.stringify(error, null, 2)}</pre>
        </details>
      )}

      <div className="custom-error-buttons">
        <button
          className="custom-error-button custom-error-button-secondary"
          onClick={() => (window.location.href = "/login")}
        >
          Ir al Login
        </button>
      </div>
    </div>
  );
};

CustomErrorComponent.propTypes = {
  error: PropTypes.object,
};

export default CustomErrorComponent;
